import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ReactNode } from 'react'
import { v4 } from 'uuid'

export type ToastType = {
  content: ReactNode
  key: string
}

type ToastStateType = {
  toasts: ToastType[]
}

const MAX_TOASTS = 3

const initialState: ToastStateType = {
  toasts: [],
}

export const toastSlice = createSlice({
  initialState,
  name: 'toast',
  reducers: {
    add: (s, { payload: content }: PayloadAction<ReactNode>) => {
      const key = v4()
      s.toasts = [...s.toasts, { content, key }].slice(-MAX_TOASTS)
    },
    remove: (s, action: PayloadAction<string>) => {
      s.toasts = s.toasts.filter((t) => t.key !== action.payload)
    },
  },
})

export const toastActions = toastSlice.actions
export const toastReducer = toastSlice.reducer
